export default __webpack_public_path__ + "static/media/kfh-color.7962950c.svg";